import _ from 'lodash';
import { useContext, useEffect } from 'react';
import { useQueryString } from 'shared/utils/helpers/convertQueryString';
import { TableFilterContext } from '../../model/context/TableFilterContextProvider';

export const useWatchTableFilterQuery = (withQueryStringFilters: boolean): void => {
  const { parsedQuery, decode, encode, getEncodedString } = useQueryString();

  const { appliedFilters, applyQueryFilters } = useContext(TableFilterContext);

  useEffect(() => {
    const queryToFilters = (): void => {
      const decodedFilter = decode(parsedQuery);

      for (const key in decodedFilter) {
        if (decodedFilter[key].value) {
          applyQueryFilters({ key, value: decodedFilter[key].value, label: decodedFilter[key].label, title: decodedFilter[key].title });
        }
      }
    };

    if (withQueryStringFilters) {
      queryToFilters();
    }
  }, [withQueryStringFilters]);

  useEffect(() => {
    const filtersToQuery = (): void => {
      // query string already matches applied filters (e.g. they were just read from it), no need to rewrite it
      if (_.isEqual(getEncodedString(appliedFilters), parsedQuery)) {
        return;
      }

      encode(appliedFilters);
    };

    if (withQueryStringFilters) {
      filtersToQuery();
    }
    // parsedQuery is a new object on every render; effect reruns on query string change anyway, because encode depends on it
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [withQueryStringFilters, appliedFilters, encode, getEncodedString]);
};
